import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1.5,1.5h1v0.5h-1zM0.5,1.5h1.5v0.5h-1.5z' },
    { paint: 'trunk', d: 'M0,-0.5h0.5v2.5h-0.5z' },
    { paint: 'firewoodLog', d: 'M-0.5,-0.5h0.5v2.5h-0.5z' },
    {
      paint: 'pine',
      d: 'M-1,-5h1v0.5h-1zM-1.5,-4.5h1.5v0.5h-1.5zM-1,-4h1v0.5h-1zM-2,-3h2v0.5h-2zM-2.5,-2.5h2.5v0.5h-2.5zM-2,-2h2.5v0.5h-2.5zM-1,-1.5h1v0.5h-1zM-3.5,-1h3.5v0.5h-3.5zM-2,-0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'bushDark',
      d: 'M-0.5,-8h0.5v0.5h-0.5zM0,-7.5h0.5v0.5h-0.5zM0.5,-6.5h0.5v0.5h-0.5zM1,-5.5h0.5v0.5h-0.5zM0,-5h1.5v1h-1.5zM0,-4h2v0.5h-2zM-0.5,-3.5h3v0.5h-3zM0,-3h2.5v1h-2.5zM0.5,-2h2v0.5h-2zM0,-1.5h3v0.5h-3zM0,-1h3.5v0.5h-3.5zM0.5,-0.5h2v0.5h-2z',
    },
    {
      paint: 'snowCap',
      d: 'M-0.5,-7.5h0.5v0.5h-0.5zM-1,-7h1.5v1h-1.5zM-1.5,-6h2.5v1h-2.5zM-2,-4h1v0.5h-1zM-2.5,-3.5h2v0.5h-2zM-3,-2h1v0.5h-1zM-3,-1.5h2v0.5h-2z',
    },
  ],
  pixels: 128,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1.5,1.5h1v0.5h-1zM0.5,1.5h1.5v0.5h-1.5z' },
    { paint: 'trunk', d: 'M0,0h0.5v2h-0.5z' },
    { paint: 'firewoodLog', d: 'M-0.5,-0.5h0.5v2.5h-0.5z' },
    {
      paint: 'pine',
      d: 'M-1.5,-5.5h1.5v0.5h-1.5zM-0.5,-5h0.5v0.5h-0.5zM-2.5,-3h0.5v0.5h-0.5zM-1.5,-3h1v0.5h-1zM-3.5,-1h0.5v0.5h-0.5zM-1.5,-1h1v0.5h-1zM-2,-0.5h1v0.5h-1z',
    },
    {
      paint: 'bushDark',
      d: 'M1.5,-6.5h0.5v0.5h-0.5zM0,-5.5h1.5v0.5h-1.5zM0,-5h2v0.5h-2zM0.5,-4.5h0.5v0.5h-0.5zM2,-4.5h0.5v0.5h-0.5zM2.5,-4h0.5v1h-0.5zM-0.5,-3h3v0.5h-3zM0,-2.5h1.5v0.5h-1.5zM3,-1.5h0.5v0.5h-0.5zM-0.5,-1h0.5v0.5h-0.5zM2.5,-1h1v0.5h-1zM0,-0.5h3v0.5h-3z',
    },
    {
      paint: 'snowCap',
      d: 'M-0.5,-9h0.5v0.5h-0.5zM-1,-8.5h1.5v0.5h-1.5zM-1.5,-8h2v0.5h-2zM-1.5,-7.5h2.5v0.5h-2.5zM-2,-7h3.5v1h-3.5zM-2,-6h4v0.5h-4zM-2,-5h1.5v0.5h-1.5zM-2.5,-4.5h3v0.5h-3zM1,-4.5h1v0.5h-1zM-3,-4h5.5v1h-5.5zM-2,-3h0.5v0.5h-0.5zM-3,-2.5h3v0.5h-3zM1.5,-2.5h1v0.5h-1zM-3.5,-2h6.5v0.5h-6.5zM-4,-1.5h7v0.5h-7zM-3,-1h1.5v0.5h-1.5zM0,-1h2.5v0.5h-2.5z',
    },
    { paint: 'icicleBlue', d: 'M-3,-0.5h0.5v0.5h-0.5z' },
  ],
  pixels: 170,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1.5,1.5h1v0.5h-1zM0.5,1.5h1.5v0.5h-1.5z' },
    { paint: 'trunk', d: 'M0,-0.5h0.5v2.5h-0.5z' },
    { paint: 'firewoodLog', d: 'M-0.5,-0.5h0.5v2.5h-0.5z' },
    {
      paint: 'ice',
      d: 'M1,-6.5h0.5v0.5h-0.5zM-1.5,-6h0.5v0.5h-0.5zM-1.5,-5.5h2v0.5h-2zM-1.5,-5h1.5v0.5h-1.5zM-2,-3.5h2v0.5h-2zM-2.5,-3h2.5v0.5h-2.5zM-3,-2.5h3.5v0.5h-3.5zM-3.5,-2h0.5v0.5h-0.5zM-1.5,-2h2v0.5h-2zM-3.5,-1h3.5v0.5h-3.5z',
    },
    {
      paint: 'frozenWater',
      d: 'M0.5,-5.5h1v0.5h-1zM0,-5h1.5v0.5h-1.5zM0.5,-4.5h1.5v0.5h-1.5zM0,-4h0.5v0.5h-0.5zM1,-4h1.5v0.5h-1.5zM0,-3.5h2.5v0.5h-2.5zM0,-3h2v0.5h-2zM0.5,-2.5h2v0.5h-2zM0.5,-2h2.5v0.5h-2.5zM0,-1.5h3.5v1h-3.5zM0.5,-0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'snowCap',
      d: 'M0,-8.5h0.5v0.5h-0.5zM-0.5,-8h1.5v0.5h-1.5zM-1,-7.5h2v1h-2zM-1.5,-6.5h2.5v0.5h-2.5zM-1,-6h2.5v0.5h-2.5zM-2,-4.5h2.5v0.5h-2.5zM-2,-4h2v0.5h-2zM0.5,-4h0.5v0.5h-0.5zM-3,-2h1.5v0.5h-1.5zM-3.5,-1.5h3.5v0.5h-3.5z',
    },
  ],
  pixels: 141,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
